import React from "react";
import { Container, Grid, Button } from "@mui/material";
import { Link } from "react-router-dom";
import earImage from "../assets/ear.webp";  // Import the image
import queImage from "../assets/question.jpg"
import aboutImage from "../assets/about.webp"
import howImage from "../assets/how.webp"


const Home = () => {
    return (
        <Container sx={{ textAlign: "center", mt: 2, minHeight: "80vh" }}>


      {/* Button Grid (2 items per row on all screens) */}
      <Grid container spacing={2} justifyContent="center" sx={{ mt: 2 }}>
        
    

        {/* Questionnaire Button */}
        <Grid item xs={6}>
          <Button
            component={Link}
            to="/questionnaire"
            variant="contained"
            sx={{
              backgroundColor: "#9fd3a8",
              width: "100%",
              height: "150px",
              p: 2,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              src={queImage}
              alt="Questionnaire"
              style={{ width: "80px", height: "80px", objectFit: "contain" }}
            />
            <span style={{ marginTop: "8px", fontSize: "12px", fontWeight: "bold" }}>
              Questionnaire
            </span>
          </Button>
        </Grid>
    {/* Conditioning Button */}
    <Grid item xs={6}>
          <Button
            component={Link}
            to="/conditioning"
            variant="contained"
            sx={{
              backgroundColor: "#a1c4fd",
              width: "100%",
              height: "150px",
              p: 2,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              src={earImage}
              alt="Conditioning"
              style={{ width: "80px", height: "80px", objectFit: "contain" }}
            />
            <span style={{ marginTop: "8px", fontSize: "12px", fontWeight: "bold" }}>
              Conditioning
            </span>
          </Button>
        </Grid>
        {/* About App Button */}
        <Grid item xs={6}>
          <Button
            component={Link}
            to="/about"
            variant="contained"
            sx={{
              backgroundColor: "#d3c3fc",
              width: "100%",
              height: "150px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontWeight: "bold",
            }}
          >
         <img
              src={aboutImage}
              alt="About"
              style={{ width: "80px", height: "80px", objectFit: "contain" }}
            />
          </Button>
        </Grid>

        {/* How to Use Button */}
        <Grid item xs={6}>
          <Button
            component={Link}
            to="/how-to-use"
            variant="contained"
            sx={{
              backgroundColor: "#d3c3fc",
              width: "100%",
              height: "150px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontWeight: "bold",
            }}
          >
             <img
              src={howImage}
              alt="How"
              style={{ width: "80px", height: "80px", objectFit: "contain" }}
            />
          </Button>
        </Grid>

      </Grid>
    </Container>
    );
};

export default Home;
